//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import shopifyIntegrationTemplate from '@legacy-components/ecommerce-integrations/integrations/shopify-integration.html';

(function() {
  angular.module('curalate').component('shopifyIntegration', {
    bindings: {
      shopifyFormValues: '=',
    },
    template: shopifyIntegrationTemplate,
    controller: [
      'SessionVarsService',
      function(
                SessionVarsService,
            ) {
        this.isShowroomEnabled = SessionVarsService.isFeatureEnabled('tributary_self_serve');

        this.toggleStorefrontApiKey = function() {
          this.showStorefrontApiKey = !this.showStorefrontApiKey;
        };

        this.$onInit = function() {
          this.showStorefrontApiKey = true;
        };
      },
    ],
  });
})();
